import React from 'react';
import { Button } from '@veeqo/ui';
import { useTranslation } from 'context/TranslationContext';

export const NavigateButton = ({ href, textId }: { href: string; textId: string }) => {
  const { t } = useTranslation();
  return (
    <Button
      onClick={() => {
        const a = document.createElement('a');
        a.href = href;
        a.rel = 'noopener noreferrer';
        a.target = '_blank';
        a.click();
      }}
      variant="default"
    >
      {t(textId)}
    </Button>
  );
};
